export default "__VITE_ASSET__a4ccfe76__"